import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularScales: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_scales"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="scales icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75C21 4.16421 20.6642 4.5 20.25 4.5H19.208L21.9446 11.217C21.9812 11.3069 22 11.403 22 11.5C22 13.433 20.433 15 18.5 15C16.567 15 15 13.433 15 11.5C15 11.403 15.0188 11.3069 15.0554 11.217L17.792 4.5H12.75L12.75 16.5H16.75C17.9926 16.5 19 17.5074 19 18.75C19 19.9926 17.9926 21 16.75 21H7.25293C6.01029 21 5.00293 19.9926 5.00293 18.75C5.00293 17.5074 6.01029 16.5 7.25293 16.5H11.25L11.25 4.5H6.208L8.94457 11.217C8.98118 11.3069 9 11.403 9 11.5C9 13.433 7.433 15 5.5 15C3.567 15 2 13.433 2 11.5C2 11.403 2.01882 11.3069 2.05543 11.217L4.792 4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM6.50293 18.75C6.50293 19.1642 6.83872 19.5 7.25293 19.5H16.75C17.1642 19.5 17.5 19.1642 17.5 18.75C17.5 18.3358 17.1642 18 16.75 18H7.25293C6.83872 18 6.50293 18.3358 6.50293 18.75ZM7.35462 12.25H3.64538C3.94207 12.983 4.66066 13.5 5.5 13.5C6.33934 13.5 7.05793 12.983 7.35462 12.25ZM7.13459 10.75L5.5 6.73782L3.86541 10.75H7.13459ZM18.5 13.5C19.3393 13.5 20.0579 12.983 20.3546 12.25H16.6454C16.9421 12.983 17.6607 13.5 18.5 13.5ZM16.8654 10.75H20.1346L18.5 6.73782L16.8654 10.75Z" />
      </svg>
    </span>
  );
};

export { RegularScales };
